import styled from "styled-components";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as Button from "../../../../../../../common-deprecated/styles/v2/lexus/components/Button";

export const Wrapper = styled.div`
    grid-column: 1 / 1;
    text-align: center;

    @media ${getBreakpoint("up", "md")} {
        grid-column: 1 / 3;
    }

    @media ${getBreakpoint("up", "lg")} {
        grid-column: 1 / 4;
    }

    ${Button.ButtonSecondary} {
        width: auto;
    }
`;

export const NoResultTextWrapper = styled.div`
    margin: ${theme.space[6]}px 0 ${theme.space[5]}px;
    text-align: center;
`;
